import React from "react";
import { QUALITIES } from "@/lib/quality";

export const Legend = () => {
  return (
    <div
      data-testid="color-legend"
      className="bg-white border border-[var(--app-border)] rounded-md shadow-sm px-4 py-3"
    >
      <div className="text-[10px] uppercase tracking-[0.18em] text-[var(--app-text-soft)] font-display font-semibold mb-2">
        Quality legend
      </div>
      <ul className="flex flex-col gap-1.5">
        {QUALITIES.map((q) => (
          <li
            key={q.value}
            className="flex items-center gap-2.5 text-xs text-[var(--app-text)]"
            data-testid={`legend-${q.value}`}
          >
            <span
              className="w-4 h-4 rounded-sm border border-black/10 shrink-0"
              style={{ backgroundColor: q.color }}
            />
            <span className="font-medium">{q.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Legend;
